(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoxo-slideshow"] && !Shopify.designMode) return;
  try {
    
function setupHoxoSlides(root=document){root.querySelectorAll('[data-hoxo-slideshow]').forEach(el=>{
 if(el.dataset.ready)return;el.dataset.ready='true';const slides=[...el.querySelectorAll('[data-hoxo-slide]')],dots=[...el.querySelectorAll('[data-hoxo-dot]')];let index=0,timer,paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const pause=el.querySelector('[data-hoxo-pause]');
 const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));};
 const stop=()=>clearInterval(timer);const start=()=>{stop();if(!paused&&slides.length>1&&!document.hidden)timer=setInterval(()=>show(index+1),6000);};
 dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
 el.querySelector('[data-hoxo-prev]').addEventListener('click',()=>{show(index-1);start();});el.querySelector('[data-hoxo-next]').addEventListener('click',()=>{show(index+1);start();});
 pause.setAttribute('aria-pressed',String(paused));pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'▶':'Ⅱ';start();});
 el.addEventListener('mouseenter',stop);el.addEventListener('mouseleave',start);el.addEventListener('focusin',stop);el.addEventListener('focusout',e=>{if(!el.contains(e.relatedTarget))start();});document.addEventListener('visibilitychange',start);
 document.addEventListener('shopify:block:select',e=>{const n=slides.findIndex(s=>s.contains(e.target)||s===e.target);if(n>=0){show(n);stop();}});start();
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setupHoxoSlides());else setupHoxoSlides();document.addEventListener('shopify:section:load',e=>setupHoxoSlides(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
